import { injectVariables } from "./string";
import cacheService from "@/services/cache";

export function getUserLocation() {
    return {
        brandId: parseInt(cacheService.getCurrentBrandId()),
        zoneId: parseInt(cacheService.getCurrentZoneId()),
        campaignId: parseInt(cacheService.getCurrentCampaignId())
    };
}

export function buildUrlFromLocation(url, location = undefined) {
    location = {
        ...getUserLocation(),
        ...location
    };
    return injectVariables(`/:brandId/:zoneId${location.campaignId ? "/:campaignId" : ""}${url}`, location);
}

/**
 * @returns {string}
 * @param url {string}
 * @param brandId {Number || undefined}
 * If non brandId is provided it uses the current brandId
 */
export function buildUrlWithBrand(url, brandId = undefined) {
    const actualBrandId = brandId || parseInt(cacheService.getCurrentBrandId());
    return injectVariables(`/:brandId${url}`, { brandId: actualBrandId });
}



// WEBPACK FOOTER //
// ./src/utils/httpUtils.js